import React from "react";

import { PaginationTypes } from "../../types/pagination";

const Pagination = ({
  currentPage,
  setCurrentPage,
  totalPages,
}: PaginationTypes) => {
  return (
    <div className="a-pagination row fullWidth justify-center">
      <button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(currentPage - 1)}
        className={`a-pagination__button ${currentPage !== 1 ? "-active" : ""}`}
      >
        &lt;
      </button>

      <div className="row -column-gap15">
        {[...Array(totalPages).keys()].map((_, index) => (
          <p
            key={index}
            className={`a-pagination__text -title ${
              currentPage === index + 1 ? "-active" : ""
            }`}
            onClick={() => setCurrentPage(index + 1)}
          >
            {index + 1}
          </p>
        ))}
      </div>

      <button
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage(currentPage + 1)}
        className={`a-pagination__button ${
          currentPage !== totalPages ? "-active" : ""
        }`}
      >
        &gt;
      </button>
    </div>
  );
};

export default Pagination;
